import { broadcastLogout } from './authLogoutBroadcast';

export type SessionInvalidator = () => boolean;

const sessionInvalidators = new Set<SessionInvalidator>();
let hasInvalidatedSession = false;

export function registerSessionInvalidator(invalidator: SessionInvalidator): void {
  sessionInvalidators.add(invalidator);
  hasInvalidatedSession = false;
}

export function unregisterSessionInvalidator(invalidator: SessionInvalidator): void {
  sessionInvalidators.delete(invalidator);
}

export function invalidateSession(options: { broadcast: boolean }): void {
  if (hasInvalidatedSession) {
    return;
  }

  let handled = false;
  sessionInvalidators.forEach((invalidator) => {
    handled = invalidator() || handled;
  });
  if (!handled) {
    return;
  }

  hasInvalidatedSession = true;
  if (options.broadcast) {
    broadcastLogout();
  }
}
